import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { IMAGEM_LOGO_CENTRUS_BASE64 } from '../../../../../../app.constants';
import { DeclIrSefModel } from '../../../../models/declIrSef.model';
import { PessoaJuridicaModel } from '../../../../models/pessoa-juridica.model';
import { PessoaDadosSimplicadosModel } from '../../../../models/pessoa-simplificada.model';
import { CnpjPipe } from '../../../../pipe/cnpj-pipe';
import { CpfPipe } from '../../../../pipe/cpf-pipe';
import { MatriculaPipe } from '../../../../pipe/matricula.pipe';
import { MesPipe } from '../../../../pipe/mes.pipe';
import { FormateNumberZeroPipe } from '../../../../pipe/format-number-zero.pipe';

@Injectable()
export class DeclaracaoRendEmpFinDetalhePdf {

  constructor(
    private _decimalPipe: DecimalPipe,
    private _matricula: MatriculaPipe,
    private _formateNumberZeroPipe: FormateNumberZeroPipe,
    private _cpf: CpfPipe,
    private _mesPipe: MesPipe,
    private _cnpj: CnpjPipe
  ) { }

  public funcionarios(anoDeclardo: number, titlePage: string, pessoaJuridicaModel: PessoaJuridicaModel,
    pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel, declIrSef: DeclIrSefModel) {

    const doc = new jsPDF('p', 'mm', 'a4');

    doc.addImage(IMAGEM_LOGO_CENTRUS_BASE64, 'PNG', 90, 20, 35, 20);
    doc.setFontSize(13);
    doc.setFont('Source Sans Pro');
    doc.setFontStyle('bold');
    doc.text(`DECLARAÇÃO PARA IRPF - ${anoDeclardo}`, 70, 50)
    doc.text(`${titlePage}`, 80, 55)

    doc.autoTable({
      startY: 60
    })


    doc.autoTable({
      theme: 'plain',
      columnStyles: {
        contentA: { fontSize: 8 },
        contentB: { fontSize: 8 }
      },
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 10,
      },
      head: [['CNPJ', 'Nome Empresarial']],
      body: [[this._cnpj.transform(pessoaJuridicaModel.cnpj), pessoaJuridicaModel.nome]],
    });



    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 10,
      },
      columnStyles: {
        0: { cellWidth: 30 }
      },
      head: [['CPF', 'Nome']],
      body: [[this._cpf.transform(pessoaDadosSimplicadosModel.cpf), pessoaDadosSimplicadosModel.nome]],
    });


    doc.setFontSize(11);
    doc.setFont('Source Sans Pro');
    doc.text(`Data Concessão  - ${declIrSef.dtLanctoCompleta}`, 14, doc.previousAutoTable.finalY + 6)

    if (declIrSef.isApresentaValor) {
      doc.text(`Data Liquidação  - ${declIrSef.dataLiquidacao}`, 90, doc.previousAutoTable.finalY + 6)
    }

    doc.autoTable({ body: [] })


    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 10,
      },
      footStyles: {
        fillColor: [226, 235, 248],
      },
      head: this._headRows(),
      body: this._bodyRows(declIrSef),
      foot: [['   ',
        `Total Prestações \n ${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declIrSef.vlTotPrest, '1.1-2'))}`,
        `Total Amortização \n ${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declIrSef.vlTotAmort, '1.1-2'))}`,
        `Total Geral \n ${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declIrSef.vlTotGeral, '1.1-2'))}`]]
    });

    doc.setFontSize(11);
    doc.setFont('Source Sans Pro');
    doc.text(`Saldo Devedor em 31/12/ ${anoDeclardo}              ${this._formateNumberZeroPipe.transform(this._decimalPipe.transform(declIrSef.vlSaldoDevedor, '1.1-2'))}`, 95, doc.previousAutoTable.finalY + 6)

    doc.setProperties({
      title: 'Declaração',
      subject: `Declaração gerado em ${new Date('dd/mm/yyy')} `,
      author: 'centrus',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'Fundação Banco central de previcência provida - centrus'
    });

    (window.innerWidth > 640)
      ? (window.open(URL.createObjectURL(doc.output('blob'))))
      : this.handleFile(doc.output('blob'), 'declaracao.pdf');
  }

  handleFile(res: any, fileName: string) {
    const file = new Blob([res], {
      type: res.type
    });

    // IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(file);
      return;
    }



    const blob = window.URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = blob;
    link.download = fileName;

    // link.click();
    link.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }));

    setTimeout(() => { // firefox
      window.URL.revokeObjectURL(blob);
      link.remove();
    }, 100);
  }

  private _bodyRows(declIrSef: DeclIrSefModel) {
    const body = []

    declIrSef.obterDeclIrSefDTO.map(item => {
      body.push({
        data: this._mesPipe.transform(item.mmTab) + '/' + item.aaTab,
        valor: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.vlPrest, '1.1-2')),
        valorAmortização: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.vlAmort, '1.1-2')),
        totalMensal: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.vlPrest, '1.1-2'))
      })
    })
    return body;
  }

  private _headRows() {
    return [{
      data: 'Data',
      valor: 'Valor (R$)',
      valorAmortização: 'Valor Amortização (R$)',
      totalMensal: 'Total Mensal'
    },
    ]
  }






}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/documentos-pdf-imprimir/financeiro/declaracao-rend-emp-fin/declaracao-rend-emp-fin-detalhe-pdf.ts